import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={10} height={16} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 14l6-6-6-6" style={{
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }} /></svg>;
}
export default SvgComponent;